{
    "404": "Oh nein! Wir haben das ganze Meer abgesucht und können die Seite nicht finden!"
}
